import React from "react";
import BuildingHeaderButtons from "./Buttons";
import BuildingHeaderName from "./Name";
import BuildingHeaderAddress from "./Address";
import { buildingStore } from "store/Building/BuildingStore";
import { observer } from "mobx-react-lite";
import CalculationProgressIndicator from "./CalculationProgressIndicator";
import { useEnsureLicensedCertification } from "hooks/useCertificationLicense";

export default observer(function BuildingHeader() {
  const { currentBuilding } = buildingStore;
  const stepperOpened = false;
  const hasLicense = currentBuilding?.license;

  // Tier 3: silently reset the in-use certification to "Keine" if the license no longer covers it.
  useEnsureLicensedCertification();

  return (
    <div className="flex justify-between flex-row items-center px-4 md:px-6 w-full">
      <div className="flex md:items-center flex-col md:flex-row">
        {currentBuilding && !stepperOpened && (
          <>
            <BuildingHeaderName name={currentBuilding.name} />
            <BuildingHeaderAddress building={currentBuilding} />
          </>
        )}
        {hasLicense && <CalculationProgressIndicator />}
      </div>
      {hasLicense && <BuildingHeaderButtons />}
    </div>
  );
});
